import { green } from '@ant-design/colors';
import { CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
  Form,
  Input,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Typography
} from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import CustomDatePicker from '../../components/CustomDatePicker';

const AutorizacionDatosVehiculo = ({
  autorizacion,
  datosConfirmados,
  setDatosConfirmados,
  setHabilitarBotonAprobar,
  form
}) => {
  const [loading, setLoading] = useState(true);
  const [vehiculoDatos, setVehiculoDatos] = useState([]);
  const [editableEmisionVehiculo, setEditableEmisionVehiculo] = useState(true);

  const renderColumnVehiculo = (record, index) => {
    let { value } = record;
    if (record.requiereRevision) {
      return (
        <Tooltip title="Este dato  requiere autorización">
          <Typography.Text type="warning">
            <span>
              {record.value}{' '}
              <InfoCircleOutlined
                style={{
                  color: 'rgba(0,0,0,.45)',
                  marginRight: '5px'
                }}
              />
            </span>
          </Typography.Text>
        </Tooltip>
      );
    }
    if (
      record.actualizado ||
      (!editableEmisionVehiculo && index === 'emision')
    ) {
      const datoFormateado = record.value;
      // record.type === 'select' ? record.descripcion : record.value;
      value = <strong>{datoFormateado}</strong>;
    }
    return value;
  };

  const columnsVehiculo = [
    {
      title: '',
      dataIndex: 'label',
      key: 'label'
    },
    {
      title: 'Cotización (Ejecutivo)',
      dataIndex: 'cotizacion',
      key: 'cotizacion',
      render: renderColumnVehiculo
    },
    {
      title: 'Cédula Verde',
      dataIndex: 'imagen',
      key: 'imagen',
      render: renderColumnVehiculo
    },
    {
      title: 'Control Sistema',
      dataIndex: 'controlSegu',
      key: 'controlSegu',
      render: renderColumnVehiculo
    },

    {
      title: 'Solicitud (Usuario)',
      dataIndex: 'solicitud',
      key: 'solicitud'
    },
    {
      title: (
        <>
          <Space>
            Datos para emisión
            <Tooltip title="Datos confirmados">
              <Typography.Text hidden={!datosConfirmados}>
                <CheckCircleOutlined
                  style={{
                    color: green.primary
                  }}
                />
              </Typography.Text>
            </Tooltip>
          </Space>
        </>
      ),
      dataIndex: 'emision',
      key: 'emision',
      width: 300,
      render: (record) => renderColumnVehiculo(record, 'emision'),
      editable: editableEmisionVehiculo
    }
  ];

  const columns = columnsVehiculo.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'emision' ? record.emision.type : '',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: true,
        editableCell: editableEmisionVehiculo && !record.emision.readonly
      })
    };
  });

  const onChangeSelect = (name) => {
    const { emision } = form.getFieldsValue();

    if (name === 'marca') {
      // setMarca(value);
      form.setFieldsValue({
        emision: {
          ...emision,
          modelo: null,
          submodelo: null,
          aniosubmodelo: null
        }
      });
    } else if (name === 'modelo') {
      // setModelo(value);
      form.setFieldsValue({
        emision: { ...emision, submodelo: null, aniosubmodelo: null }
      });
    } else if (name === 'aniosubmodelo') {
      //  setAnio(value);
      form.setFieldsValue({ emision: { ...emision, submodelo: null } });
    } else if (name === 'submodelo') {
      // setSubmodelo(value);
    }
  };

  const EditableCell = ({
    editing,
    dataIndex,
    record,
    children,
    editableCell
  }) => {
    let inputNode = null;
    const optionsSelect = [];
    let nameElement;
    if (dataIndex && record[dataIndex]?.name) {
      nameElement = dataIndex && record[dataIndex]?.name;
      /* if (nameElement === 'marca') {
        optionsSelect = getOptions(marcas);
      } else if (nameElement === 'modelo') {
        optionsSelect = getOptions(modelos);
      } else if (nameElement === 'aniosubmodelo') {
        optionsSelect = getOptions(anios);
      } else if (nameElement === 'submodelo') {
        optionsSelect = getOptions(submodelos);
      } */
    }

    switch (dataIndex && record[dataIndex]?.type) {
      case 'input':
        inputNode = <Input />;
        break;
      case 'select':
        inputNode = (
          <Select onChange={(value) => onChangeSelect(nameElement, value)}>
            {optionsSelect}
          </Select>
        );
        break;
      case 'date':
        inputNode = (
          <CustomDatePicker
            style={{ width: '100%' }}
            placeholder="DD/MM/YYYY"
            format="DD/MM/YYYY"
          />
        );
        break;
      default:
        inputNode = <Input />;
    }

    const nameCol = dataIndex ? record[dataIndex]?.name : null;
    const content = dataIndex === 'emision' ? children : children;

    return (
      <td>
        {editing && nameCol && editableCell ? (
          <Form.Item
            name={[dataIndex, nameCol]}
            style={{ margin: 0 }}
            rules={[{ required: true, message: 'Requerido' }]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          content
        )}
      </td>
    );
  };

  const components = {
    body: {
      cell: EditableCell
    }
  };

  /* const getOptions = (list) => {
    return list.map(({ id, descripcion }) => (
      <Option key={`${id}${descripcion}`} value={id}>
        {descripcion}
      </Option>
    ));
  };

   const getMarcas = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      errorHandler(error, error.message);
    }
  }, []);

  const getModelos = useCallback(async () => {
    try {
      const { emision } = form.getFieldsValue();
      if (emision?.marca) {
        const response = await instanceRef.instance.get(`data/modelos`, {
          params: { marca: emision?.marca }
        });
        const orderedModelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];
        setModelos(orderedModelos);
      }
    } catch (error) {
      errorHandler(error, error.message);
    }
  }, [form]);

  const getAnios = useCallback(async () => {
    try {
      const { emision } = form.getFieldsValue();

      if (emision?.marca && emision?.modelo) {
        const response = await instanceRef.instance.get(`data/anios`, {
          params: { marca: emision.marca, modelo: emision.modelo }
        });
        const orderedAnios = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (parseInt(a.descripcion) < parseInt(b.descripcion)) {
                return 1;
              }
              if (parseInt(a.descripcion) > parseInt(b.descripcion)) {
                return -1;
              }
              return 0;
            })
          : [];
        setAnios(orderedAnios);
      }
    } catch (error) {
      errorHandler(error, error.message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubmodelos = useCallback(async () => {
    try {
      const { emision } = form.getFieldsValue();
      if (emision?.marca && emision?.modelo && emision?.aniosubmodelo) {
        const response = await instanceRef.instance.get(`data/submodelos`, {
          params: {
            marca: emision.marca,
            modelo: emision.modelo,
            anio: emision.aniosubmodelo
          }
        });
        const orderedSubmodelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];
        setSubmodelos(orderedSubmodelos);
      }
    } catch (error) {
      errorHandler(error, error.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); */

  const cargarDatosVehiculo = useCallback(async () => {
    const autorizacionVehiculo = autorizacion.detalle?.vehiculo;
    const vehiculoDatosList = [
      {
        key: 'marca',
        label: 'Marca',
        cotizacion: {
          requiereRevision:
            autorizacionVehiculo.cotizacion?.marcaRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.marca
        },
        imagen: {
          requiereRevision: autorizacionVehiculo.imagen?.marcaRequiereRevision,
          value: autorizacionVehiculo.imagen?.marca
        },
        controlSegu: {
          requiereRevision: autorizacionVehiculo.bcp?.marcaRequiereRevision,
          value: autorizacionVehiculo.bcp?.marca
        },

        solicitud: autorizacionVehiculo.solicitud?.marca?.descripcion,
        emision: {
          type: 'select',
          name: 'marca',
          value: autorizacionVehiculo.emision?.marca?.descripcion,
          // descripcion: autorizacionVehiculo.emision?.marca?.descripcion,
          actualizado: autorizacionVehiculo.emision?.actualizado || false,
          readonly: true
        }
      },
      {
        key: 'modelo',
        label: 'Modelo',
        cotizacion: {
          requiereRevision:
            autorizacionVehiculo.cotizacion?.modeloRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.modelo
        },
        imagen: {
          requiereRevision: autorizacionVehiculo.imagen?.modeloRequiereRevision,
          value: autorizacionVehiculo.imagen?.modelo
        },
        controlSegu: {
          requiereRevision: autorizacionVehiculo.bcp?.modeloRequiereRevision,
          value: autorizacionVehiculo.bcp?.modelo
        },
        solicitud: autorizacionVehiculo.solicitud?.modelo?.descripcion,
        emision: {
          type: 'select',
          name: 'modelo',
          value: autorizacionVehiculo.emision?.modelo
            ? autorizacionVehiculo.emision?.modelo.descripcion
            : null,
          //  descripcion: autorizacionVehiculo.emision?.modelo.descripcion,
          actualizado: autorizacionVehiculo.emision?.actualizado || false,
          readonly: true
        }
      },
      {
        key: 'aniosubmodelo',
        label: 'Año',
        cotizacion: {
          requiereRevision:
            autorizacionVehiculo.cotizacion?.anioSubmodeloRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.aniosubmodelo
        },
        imagen: {
          requiereRevision:
            autorizacionVehiculo.imagen?.anioSubmodeloRequiereRevision,
          value: autorizacionVehiculo.imagen?.aniosubmodelo
        },
        controlSegu: {
          requiereRevision: false,
          value: autorizacionVehiculo.bcp?.aniosubmodelo
        },

        solicitud: autorizacionVehiculo.solicitud?.aniosubmodelo?.descripcion,
        emision: {
          type: 'select',
          name: 'aniosubmodelo',
          value: autorizacionVehiculo.emision?.aniosubmodelo.descripcion,
          // descripcion: autorizacionVehiculo.emision?.aniosubmodelo.descripcion,
          actualizado: autorizacionVehiculo.emision?.actualizado || false,
          readonly: true
        }
      },
      {
        key: 'submodelo',
        label: 'Submodelo',
        cotizacion: {
          requiereRevision: false,
          // autorizacionVehiculo.cotizacion?.submodeloRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.submodelo
        },
        imagen: {
          requiereRevision: false,
          // autorizacionVehiculo.imagen?.submodeloRequiereRevision,
          value: autorizacionVehiculo.imagen?.submodelo
        },
        controlSegu: {
          requiereRevision: false,
          // autorizacionVehiculo.bcp?.submodeloRequiereRevision,
          value: autorizacionVehiculo.bcp?.submodelo
        },

        solicitud: autorizacionVehiculo.solicitud?.submodelo?.descripcion,
        emision: {
          type: 'select',
          name: 'submodelo',
          value: autorizacionVehiculo.emision?.submodelo?.descripcion,
          // descripcion: autorizacionVehiculo.emision?.submodelo?.descripcion,
          actualizado: autorizacionVehiculo.emision?.actualizado || false,
          readonly: true
        }
      },
      {
        key: 'chapa',
        label: 'Chapa',
        cotizacion: {
          requiereRevision: false,
          value: ''
        },
        imagen: {
          requiereRevision: autorizacionVehiculo.imagen?.chapaRequiereRevision,
          value: autorizacionVehiculo.imagen?.chapa
        },
        controlSegu: {
          requiereRevision: autorizacionVehiculo.chapa,
          value: autorizacionVehiculo.bcp?.chapa
        },
        solicitud: autorizacionVehiculo.solicitud?.chapa,
        emision: {
          type: 'input',
          name: 'chapa',
          value: autorizacionVehiculo.emision?.chapa,
          actualizado: autorizacionVehiculo.emision?.actualizado || false
        }
      },
      {
        key: 'chassis',
        label: 'Chassis',
        cotizacion: {
          requiereRevision:
            autorizacionVehiculo.cotizacion?.chassisRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.chassis
        },
        imagen: {
          requiereRevision:
            autorizacionVehiculo.imagen?.chassisRequiereRevision,
          value: autorizacionVehiculo.imagen?.chassis
        },
        controlSegu: {
          requiereRevision: autorizacionVehiculo.bcp?.chassisRequiereRevision,
          value: autorizacionVehiculo.bcp?.chassis
        },

        solicitud: autorizacionVehiculo.solicitud?.chassis,
        emision: {
          type: 'input',
          name: 'chassis',
          value: autorizacionVehiculo.emision?.chassis,
          actualizado: autorizacionVehiculo.emision?.actualizado || false
        }
      }
      /* {
        key: 'pais',
        label: 'Procedencia',
        cotizacion: {
          requiereRevision:
            autorizacionVehiculo.cotizacion?.paisRequiereRevision,
          value: autorizacionVehiculo.cotizacion?.pais
        },
        imagen: {
          requiereRevision: autorizacionVehiculo.imagen?.paisRequiereRevision,
          value: autorizacionVehiculo.imagen?.pais
        },
        controlSegu: {
          requiereRevision: autorizacionVehiculo.bcp?.paisRequiereRevision,
          value: autorizacionVehiculo.bcp?.pais
        },

        solicitud: autorizacionVehiculo.solicitud?.pais,
        emision: {
          type: 'input',
          name: 'pais',
          value: autorizacionVehiculo.emision?.pais,
          actualizado: autorizacionVehiculo.emision?.actualizado || false
        }
      } */
    ];
    setVehiculoDatos(vehiculoDatosList);

    const initialValues = {};
    vehiculoDatosList.forEach((data) => {
      if (data.emision && data.emision.name && data.emision.value) {
        if (data.emision.type !== 'date') {
          initialValues[data.emision.name] = data.emision.value;
        } else if (moment(data.emision.value).isValid) {
          initialValues[data.emision.name] = moment(data.emision.value);
        }
      }
    });
    form.setFieldsValue({
      emision: { ...initialValues }
    });

    setLoading(false);
  }, [autorizacion.detalle?.vehiculo, form]);

  const resaltarRevision = (record) => {
    return record.controlSegu?.requiereRevision ||
      record.cotizacion?.requiereRevision ||
      record.imagen?.requiereRevision ||
      record.bcp?.requiereRevision
      ? 'ant-table-row-selected'
      : '';
  };

  useEffect(() => {
    if (datosConfirmados) {
      setEditableEmisionVehiculo(false);
    } else {
      setEditableEmisionVehiculo(true);
    }
  }, [datosConfirmados]);

  useEffect(() => {
    const fetchData = async () => {
      if (autorizacion && autorizacion.detalle?.vehiculo) {
        cargarDatosVehiculo();

        if (autorizacion.estado !== 'PENDIENTE') {
          setEditableEmisionVehiculo(false);
        }
      }
    };

    fetchData();
  }, [
    autorizacion,
    cargarDatosVehiculo,
    setEditableEmisionVehiculo,
    setDatosConfirmados,
    setHabilitarBotonAprobar
  ]);

  return (
    <div style={{ overflowX: 'auto', textAlign: 'center' }}>
      <Spin
        spinning={loading}
        size="small"
        tip="Cargando..."
        style={{ overflowX: 'auto', textAlign: 'center' }}
      >
        {vehiculoDatos && (
          <>
            <Form form={form} component={false}>
              <Table
                components={components}
                dataSource={vehiculoDatos}
                columns={columns}
                pagination={false}
                size="small"
                style={{ overflowX: 'auto' }}
                rowKey={(record) => record.key}
                rowClassName={(record) => resaltarRevision(record)}
              />
              <br />
            </Form>
          </>
        )}
      </Spin>
    </div>
  );
};

export default AutorizacionDatosVehiculo;
